<template>
  <section id="teste" class="main card plans section--full-width">
    <header class="card-header">
      <h2>Meus recibos</h2>
    </header>

    <article class="receipts">
      <receipts-list />
    </article>
  </section>
</template>

<script>
import receiptsList from './receiptsList.vue'

export default {
  name: 'DrPlansReceipts',

  components: {
    receiptsList
  },

  created () {
    this.fn_HIDE_PROGRESS()
  },

  mounted () {}
}
</script>

<style lang="scss" scoped>
.receipts {
  padding: 0 30px 30px 30px;
}
</style>
